import React from 'react';
import {useLocation} from "react-router-dom";
import {GET_APP_LOCALIZE_TEXT, GET_WEBSITE_LOCALIZE_TEXT} from "../../utils/dq_lc_service/lc_service";
import styled from "styled-components";

const Footer = (props) => {

    const location = useLocation();
    const pageLc = location.pathname.split('/')[1];
    const Footer = styled.footer`
        display: ${props => props.theme.displayVariant.display};
    `;
    return (
        <Footer className={'dq-app-footer'}>
            <a className={'dq-footer-link'} href={'/privacy_policy'} target={'_blank'}>{GET_APP_LOCALIZE_TEXT(pageLc, 'persist_guest__privacy_policy')}</a>
            <span>|</span>
            <a className={'dq-footer-link'} href={'/terms_of_use'} target={'_blank'}>{GET_APP_LOCALIZE_TEXT(pageLc, 'persist_guest__terms_of_use')}</a>
            <div className={'dq-copyright'}>&copy; {new Date().getFullYear()} {GET_WEBSITE_LOCALIZE_TEXT(pageLc, 'home__dq_lab_pte_ltd_all_rights_reserved')}</div>
        </Footer>
    );
}

export default Footer;